/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitiateLoginWithEmailMutationVariables = GraphQL.Exact<{
  email: GraphQL.Scalars['String']['input'];
}>;


export type InitiateLoginWithEmailMutation = { readonly __typename?: 'Mutation', readonly InitiateLoginWithEmail: { readonly __typename?: 'InitiateLoginWithEmailResult', readonly hasPassword: boolean } };

export type LoginWithCredentialsMutationVariables = GraphQL.Exact<{
  email: GraphQL.Scalars['String']['input'];
  password: GraphQL.Scalars['String']['input'];
}>;


export type LoginWithCredentialsMutation = { readonly __typename?: 'Mutation', readonly LoginWithCredentials: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly displayName: string, readonly id: CK.AccountId, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithAccount>, readonly connectedClientAccounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId }>, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly id: CK.InvitationId, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithInvitation> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithUser> } }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly displayName: string, readonly id: CK.WebsiteId, readonly isCrawlingPaused: boolean, readonly isDiscovered: boolean, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite> }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly hasLimitedWebsitesAccess: boolean, readonly isOnboardingTourInProgress: boolean | null, readonly isOwner: boolean, readonly role: GraphQL.UserRole, readonly account: { readonly __typename?: 'Account', readonly canSignup: boolean, readonly currency: GraphQL.Currency | null, readonly customerType: GraphQL.CustomerType | null, readonly displayName: string, readonly endUserPlan: GraphQL.EndUserPlan | null, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithAccount>, readonly id: CK.AccountId, readonly isCleanedUp: boolean, readonly isDemoAvailable: boolean, readonly isOutOfBand: boolean, readonly isPartner: boolean, readonly isProfileCompletenessAvailable: boolean, readonly isSuitableForTrialRevival: boolean, readonly isTrialBarDisplayed: boolean, readonly name: string | null, readonly phase: GraphQL.AccountPhase, readonly plan: GraphQL.AccountPlan | null, readonly state: GraphQL.AccountState, readonly tariff: string, readonly trialExpirationDate: CK.Timestamp | null, readonly type: GraphQL.AccountType, readonly features: ReadonlyArray<{ readonly __typename?: 'AccountFeatureState', readonly feature: GraphQL.AccountFeature, readonly id: CK.ID }>, readonly legalDocumentRequirements: ReadonlyArray<{ readonly __typename?: 'LegalDocumentRequirement', readonly acceptedAt: CK.Timestamp | null, readonly documentType: GraphQL.LegalDocumentType, readonly requirement: GraphQL.LegalDocumentRequirementType }>, readonly premiumTrialOffer: { readonly __typename?: 'AccountPremiumTrialOffer', readonly durationInDays: number, readonly plan: GraphQL.AccountPlan } | null, readonly profileCompleteness: { readonly __typename?: 'AccountProfileCompleteness', readonly percentage: number, readonly tasks: ReadonlyArray<{ readonly __typename?: 'AccountProfileCompletenessTaskStatus', readonly isDone: boolean, readonly occurrences: number | null, readonly type: GraphQL.AccountProfileCompletenessTask }> } | null }, readonly user: { readonly __typename?: 'User', readonly displayName: string, readonly email: string, readonly firstName: string | null, readonly id: string, readonly initials: string, readonly isPlatformTourWebinarOfferingAvailable: boolean, readonly jobTitle: string | null, readonly lastName: string | null, readonly legacyId: string, readonly locale: string, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithUser>, readonly platformTourWebinarOffering: GraphQL.PlatformTourWebinarOffering, readonly signature: string, readonly personalTweaks: { readonly __typename?: 'UserPersonalTweaks', readonly hiddenDashboardScopes: ReadonlyArray<Record<string, any>>, readonly pageDetailSourceMode: GraphQL.PageDetailSourceMode } | null }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly displayName: string, readonly id: CK.WebsiteId, readonly pageCapacity: number, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite>, readonly problem: GraphQL.WebsiteProblem | null, readonly timeCreatedAt: CK.Timestamp }> }> } | null } } };


export const InitiateLoginWithEmailDocument = gql`
    mutation InitiateLoginWithEmail($email: String!) {
  InitiateLoginWithEmail(email: $email) {
    hasPassword
  }
}
    `;
export type InitiateLoginWithEmailMutationFn = Apollo.MutationFunction<InitiateLoginWithEmailMutation, InitiateLoginWithEmailMutationVariables>;

/**
 * __useInitiateLoginWithEmailMutation__
 *
 * To run a mutation, you first call `useInitiateLoginWithEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateLoginWithEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateLoginWithEmailMutation, { data, loading, error }] = useInitiateLoginWithEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInitiateLoginWithEmailMutation(baseOptions?: Apollo.MutationHookOptions<InitiateLoginWithEmailMutation, InitiateLoginWithEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateLoginWithEmailMutation, InitiateLoginWithEmailMutationVariables>(InitiateLoginWithEmailDocument, options);
      }
export type InitiateLoginWithEmailMutationHookResult = ReturnType<typeof useInitiateLoginWithEmailMutation>;
export type InitiateLoginWithEmailMutationResult = Apollo.MutationResult<InitiateLoginWithEmailMutation>;
export type InitiateLoginWithEmailMutationOptions = Apollo.BaseMutationOptions<InitiateLoginWithEmailMutation, InitiateLoginWithEmailMutationVariables>;
export const LoginWithCredentialsDocument = gql`
    mutation LoginWithCredentials($email: String!, $password: String!) {
  LoginWithCredentials(email: $email, password: $password) {
    query {
      authenticatedSession {
        accounts {
          connectedClientAccounts {
            id
          }
          displayName
          id
          invitations {
            id
            permittedActions
          }
          memberships {
            account {
              id
            }
            user {
              id
              legacyId
              permittedActions
            }
          }
          permittedActions
          websites {
            displayName
            id
            isCrawlingPaused
            isDiscovered
            permittedActions
          }
        }
        memberships {
          account {
            canSignup
            currency
            customerType
            displayName
            endUserPlan
            permittedActions
            features {
              feature
              id
            }
            id
            isCleanedUp
            isDemoAvailable
            isOutOfBand
            isPartner
            isProfileCompletenessAvailable
            isSuitableForTrialRevival
            isTrialBarDisplayed
            legalDocumentRequirements {
              acceptedAt
              documentType
              requirement
            }
            name
            phase
            plan
            premiumTrialOffer {
              durationInDays
              plan
            }
            profileCompleteness {
              percentage
              tasks {
                isDone
                occurrences
                type
              }
            }
            state
            tariff
            trialExpirationDate
            type
          }
          hasLimitedWebsitesAccess
          isOnboardingTourInProgress
          isOwner
          role
          user {
            displayName
            email
            firstName
            id
            initials
            isPlatformTourWebinarOfferingAvailable
            jobTitle
            lastName
            legacyId
            locale
            permittedActions
            personalTweaks {
              hiddenDashboardScopes
              pageDetailSourceMode
            }
            platformTourWebinarOffering
            signature
          }
          websites {
            displayName
            id
            pageCapacity
            permittedActions
            problem
            timeCreatedAt
          }
        }
      }
    }
  }
}
    `;
export type LoginWithCredentialsMutationFn = Apollo.MutationFunction<LoginWithCredentialsMutation, LoginWithCredentialsMutationVariables>;

/**
 * __useLoginWithCredentialsMutation__
 *
 * To run a mutation, you first call `useLoginWithCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithCredentialsMutation, { data, loading, error }] = useLoginWithCredentialsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginWithCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithCredentialsMutation, LoginWithCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithCredentialsMutation, LoginWithCredentialsMutationVariables>(LoginWithCredentialsDocument, options);
      }
export type LoginWithCredentialsMutationHookResult = ReturnType<typeof useLoginWithCredentialsMutation>;
export type LoginWithCredentialsMutationResult = Apollo.MutationResult<LoginWithCredentialsMutation>;
export type LoginWithCredentialsMutationOptions = Apollo.BaseMutationOptions<LoginWithCredentialsMutation, LoginWithCredentialsMutationVariables>;